import { render, staticRenderFns } from "./DormitoryRental.vue?vue&type=template&id=5748aa4a&scoped=true"
import script from "./DormitoryRental.vue?vue&type=script&lang=js"
export * from "./DormitoryRental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5748aa4a",
  null
  
)

export default component.exports